import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DEFAULT_LANGUAGE } from "./language";
import { localized } from "./content";

// Re-renders on a language switch, like every useTranslation consumer.
export function useCurrentLanguage() {
	const { i18n } = useTranslation();
	return i18n.resolvedLanguage ?? DEFAULT_LANGUAGE;
}

// `const l = useLocalized();` then `l(course, "name")`.
export function useLocalized() {
	const language = useCurrentLanguage();
	return useCallback((entity, field) => localized(entity, field, language), [language]);
}
